(function () {
  'use strict';

  // Smooth scroll for hash links
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id && id.length > 1) {
        var el = document.querySelector(id);
        if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  });

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    var sel = '.diff-item, .svc-row, .result-card, .team-card, .loc-card, .tl-step, .faq-item, .svc-process-step, .pricing-tier, .article-card';
    document.querySelectorAll(sel).forEach(function (el) { el.classList.add('rise'); io.observe(el); });
  }

  // Click-to-play video frames (used in video-story section)
  document.querySelectorAll('.video-frame').forEach(function (frame) {
    var video = frame.querySelector('video');
    if (!video) return;
    frame.addEventListener('click', function () {
      if (frame.classList.contains('playing')) {
        video.pause();
        frame.classList.remove('playing');
      } else {
        video.play();
        frame.classList.add('playing');
        video.controls = true;
      }
    });
    video.addEventListener('ended', function () {
      frame.classList.remove('playing');
      video.controls = false;
      video.currentTime = 0;
    });
  });

  // Mobile: pause autoplay hero video if data saver is on
  if (navigator.connection && navigator.connection.saveData) {
    document.querySelectorAll('.video-hero video').forEach(function (v) {
      v.pause(); v.removeAttribute('autoplay');
    });
  }
})();
